'use client'

import { getBugsnag } from '@/utils/bugsnag.client'

export default function BugsnagInit() {
  if (
    typeof window !== 'undefined' &&
    /\/inactive-account\/recovery\/?$/.test(window.location.pathname)
  )
    return null
  getBugsnag()
  return null
}
